<app-vini-vendibili-header
  [vini]="vini"
  [pacchetti]="pacchetti"
  [vinoSelezionato]="vinoSelezionato"
  (filtra)="filtra($event)"
  *ngIf="!fromBase"
></app-vini-vendibili-header>
<div class="tipiWrapper mt-different">
  <div
    class="vino"
    *ngFor="let vino of viniFiltered; let idx = index"
    [ngClass]="menageVisibility(vino)"
    id="vino__{{ vino.id }}"
  >
    <div class="left__side__content">
      <div class="image__container">
        <img
          src="{{ vino.imgsrc }}"
          alt="Immagine bottiglia vino {{ vino.nome }}"
          title="Immagine bottiglia vino {{ vino.nome }}"
          class="image__img"
        />
      </div>
    </div>
    <div class="right__side__content">
      <app-dettaglio-vino
        [vino]="vino"
        [codiceForm]="codiceForm"
        [linguaCorrente]="linguaCorrente"
        [vinoSelezionato]="vinoSelezionato"
        [canBack]="canBack"
        (selezionaVino)="selezionaVino($event)"
        [idx]="vino.id"
        [fromBase]="fromBase"
        (goBack)="tornaIndietro($event)"
      ></app-dettaglio-vino>
      <div
        class="d-flex justify-content-start"
        *ngIf="vinoSelezionato && vinoSelezionato.disponibile"
      >
        <div class="button__container">
          <button class="button__booking" (click)="goToLast()">
            {{ "base.scegli_qta" | translate }}
            <span class="material-symbols-outlined"> shopping_cart </span>
          </button>
        </div>
      </div>
      <div id="midbase">
        <div *ngIf="vinoSelezionato && showLastStep" id="last_step">
          <app-acquisto-vino
            [vino]="vinoSelezionato"
            (refreshCart)="refreshCart()"
          ></app-acquisto-vino>
        </div>
      </div>
    </div>
  </div>
</div>
